<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="svg-icon">
    <path
      d="M13.71,1,19,6.44V14.1L13.74,19H6.26L1,14.1V6.44L6.29,1Z"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
    />
    <path
      d="M10,4v6.5l3.5,4"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
    />
  </svg>
</template>
